import HTTP from "../../utility/http";
import { asyncHandler } from "@/utility/async";

const state = {
  pricing: {},
};

const getters = {
  getPricing: (state) => state.pricing,
};

const actions = {
  async get_pricing({ commit }) {
    const resp = await asyncHandler(HTTP({ url: "pricing", method: "GET" }));
    if (resp.success) {
      commit("set_pricing", resp.pricing);
    }
    return resp;
  },

  async save_pricing(context, data) {
    return await asyncHandler(HTTP({ url: "pricing", method: "PUT", data }));
  },
};

const mutations = {
  set_pricing: (state, pricing) => {
    state.pricing = pricing;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
